import { render, staticRenderFns } from "./ManageDeviceCardsList.vue?vue&type=template&id=21032854"
import script from "./ManageDeviceCardsList.vue?vue&type=script&lang=js"
export * from "./ManageDeviceCardsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports